import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { createJSONStorage } from 'zustand/middleware';

import { PopulationType } from '../../common/Constants';
import {
  PlanSelectorState,
  StoreKeys,
  initialState,
} from './planSelectorStore';

const store = (set): PlanSelectorState => ({
  ...initialState,
  [StoreKeys.PLAN_INFO]: {},
  [StoreKeys.SET_BIGN]: (planToken, bigN) =>
    set((state) => ({
      planInfo: {
        ...state.planInfo,
        [planToken]: {
          ...state.planInfo[planToken],
          bigN,
        },
      },
    })),

  [StoreKeys.SET_PLAN_INFO]: (
    planToken,
    coverageTypeReciprocityIdMap,
    planName,
    population
  ) =>
    set((state) => ({
      planInfo: {
        ...state.planInfo,
        [planToken]: {
          ...state.planInfo[planToken],
          coverageTypeReciprocityIdMap,
          planName,
          population:
            population === PopulationType.DSNP ? 'Medicare' : population,
        },
      },
    })),

  [StoreKeys.CLEAR_PLANINFO]: (planContextIds) => {
    const planTokens = planContextIds?.split(':');
    set((state) => ({
      planInfo: clearPlanInfoByTokens(planTokens, state),
    }));
  },
});

const clearPlanInfoByTokens = (planTokens, state) => {
  const newPlanInfo = {};
  planTokens?.forEach((token) => {
    newPlanInfo[token] = state.planInfo[token];
  });
  return newPlanInfo;
};

const planSelectorStore = persist(store, {
  name: 'planSelectorStore',
  storage: createJSONStorage(() => sessionStorage),
});

export const usePlanSelectorStore = create(devtools(planSelectorStore));
